import React, { useState } from 'react'
import styles from '../modalComponent.module.scss'
import Checked from '../../../../../icons/radioChecked.svg'
import UnChecked from '../../../../../icons/radioUnchecked.svg'
import Robbot from '../../../../../icons/robbot.svg'
import Vector from '../../../../../icons/vectorBottom.svg'
import Button from '../../../../UiKitComponents/Button'
import {
  closeConfirmationModal,
  setConfirmationModal,
} from '../../../../../redux/actions/confirmationModal'
import {
  setEditFromSummary,
  setStartDate,
} from '../../../../../redux/actions/quizQuestions'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import logOut from '../../../../../redux/thunks/account/logOut'
import ChangeDateFromTo from '../ChangeDateFromTo'

const CareRespiteDate = () => {
  const [checked, setChecked] = useState('')
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { formCopy } = useSelector((state) => state.quizQuestions)
  const checkDate = [
    'Antrag für Verhinderungspflege BIS zum 30. Juni 2025',
    'Antrag für Verhinderungspflege AB dem 01. Juli 2025',
  ]
  const handleChange = (date) => {
    setChecked(date)
  }
  const handleBack = () => {
    if (!localStorage.getItem('accessToken')) {
      navigate('/')
      dispatch(logOut())
    } else {
      navigate('/profile')
    }
    dispatch(closeConfirmationModal())
  }
  const handleConfirmDate = () => {
    checked === 'Antrag für Verhinderungspflege BIS zum 30. Juni 2025'
      ? dispatch(setStartDate(false))
      : dispatch(setStartDate(true))
    dispatch(closeConfirmationModal())
  }
  return (
    <section>
      <div className={styles.message}>
        <div className={styles.robbot}>
          <div className={styles.messageRobot}>
            <img src={Vector} alt={Vector} />
            <p>
              Hinweis: Mit dem<span>&nbsp;01. Juli 2025&nbsp;</span>sind neue
              Regelungen für die Verhinderungspflege in Kraft getreten. Wenn Sie
              Verhinderungspflege für einen Zeitraum beantragen möchten, der sich
              über beide Zeitabschnitte erstreckt, stellen Sie bitte zwei separate
              Anträge.
            </p>
          </div>
          <img src={Robbot} alt={Robbot} />
        </div>
        <div className={styles.selectDate}>
          <p>Wann war die Verhinderungspflege?</p>
          <div>
            {checkDate.map((date, index) => {
              return (
                <div onClick={() => handleChange(date)} key={index}>
                  <img
                    src={checkDate[index] === checked ? Checked : UnChecked}
                    alt={checkDate[index]}
                  />
                  <p>{date}</p>
                </div>
              )
            })}
          </div>
        </div>
        <div className={styles.submit}>
          <Button smallPrimaryNotBg onClick={handleBack}>
            Abbrechen
          </Button>
          <Button smallPrimaryBg onClick={handleConfirmDate} disabled={!checked}>
            Weiter
          </Button>
        </div>
      </div>
    </section>
  )
}
export default CareRespiteDate
